import { render, staticRenderFns } from "./comments.vue?vue&type=template&id=2f43bcdb"
import script from "./comments.vue?vue&type=script&lang=ts"
export * from "./comments.vue?vue&type=script&lang=ts"
import style0 from "./comments.vue?vue&type=style&index=0&id=2f43bcdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports